// TODO this should likely be turend into a wysiwyg block and use npm @contentful/rich-text-react-renderer
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const { quote_container, quote_left, quote_right } = styles;

// ---------------------------------------------------------

const Quote = (props) => {
  const { body } = props;

  // ---------------------------------------------------------

  const classes = classNames(quote_container);

  // ---------------------------------------------------------

  return (
    <section className={`${classes}`}>
      {/* TODO: get real quote svg or png */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={quote_left}>
        <path d="M96 224C84.72 224 74.05 226.3 64 229.9V224c0-35.3 28.7-64 64-64c17.67 0 32-14.33 32-32S145.7 96 128 96C57.42 96 0 153.4 0 224v96c0 53.02 42.98 96 96 96s96-42.98 96-96S149 224 96 224zM352 224c-11.28 0-21.95 2.305-32 5.879V224c0-35.3 28.7-64 64-64c17.67 0 32-14.33 32-32s-14.33-32-32-32c-70.58 0-128 57.42-128 128v96c0 53.02 42.98 96 96 96s96-42.98 96-96S405 224 352 224z" />
      </svg>
      <p>{body}</p>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={quote_right}>
        <path d="M96 96C42.98 96 0 138.1 0 192s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192C192 138.1 149 96 96 96zM448 192c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192z" />
      </svg>
    </section>
  );
};

Quote.propTypes = {
  /**
   * text for quote
   */
  body: PropTypes.string
};

export default Quote;
